import { doc, runTransaction, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

const lastWrite = new Map<string, number>();

function throttled(key: string, minGapMs: number): boolean {
  const now = Date.now();
  const previous = lastWrite.get(key) ?? 0;
  if (now - previous < minGapMs) return false;
  lastWrite.set(key, now);
  return true;
}

/** Marca o início da vigilância. Só a primeira vez vale; não renova ao reentrar. */
export async function armRoomIdleWatch(roomId: string): Promise<void> {
  if (!roomId || !throttled(`arm:${roomId}`, 60_000)) return;
  try {
    const ref = doc(db, "rooms", roomId);
    await runTransaction(db, async (transaction) => {
      const snap = await transaction.get(ref);
      if (!snap.exists() || snap.data()?.idleWatchStartedAt) return;
      transaction.update(ref, { idleWatchStartedAt: serverTimestamp() });
    });
  } catch (error) {
    lastWrite.delete(`arm:${roomId}`);
    console.warn("armRoomIdleWatch", error);
  }
}

/** Microfone, câmera ou movimento de avatar. Desligado / parado não gera sinal. */
export async function noteRoomMediaActivity(
  roomId: string,
  kind: "mic" | "camera" | "avatar",
): Promise<void> {
  if (!roomId || !throttled(`${kind}:${roomId}`, kind === "avatar" ? 5_000 : 15_000)) return;
  const field =
    kind === "mic" ? "micActivityAt" : kind === "camera" ? "cameraActivityAt" : "avatarActivityAt";
  try {
    await updateDoc(doc(db, "rooms", roomId), { [field]: serverTimestamp() });
  } catch (error) {
    lastWrite.delete(`${kind}:${roomId}`);
    console.warn("noteRoomMediaActivity", error);
  }
}
